var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BufferingSequencerFactory } from './buffering-sequencer-factory';
export class AnnotationSequencer {
    constructor(bufferingTimeMs = 500, sequencerFactory) {
        this.sequencerFactory = sequencerFactory !== null && sequencerFactory !== void 0 ? sequencerFactory : new BufferingSequencerFactory(bufferingTimeMs);
    }
    sequence(annotation) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const seq = (_a = annotation === null || annotation === void 0 ? void 0 : annotation.M_) === null || _a === void 0 ? void 0 : _a.seq;
            if (seq === null || seq === undefined) {
                // no annotation or no sequence number - nothing to do here
                return;
            }
            const sequencer = this.sequencerFactory.create(annotation);
            if (!sequencer) {
                return;
            }
            yield sequencer.sequence(annotation.M_.seq);
        });
    }
}
//# sourceMappingURL=annotation-sequencer.js.map